/* ============================================================
   Écru — theme.js
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {

  /* ─── HEADER SCROLL ─── */
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 10);
    }, { passive: true });
  }

  /* ─── HERO SLIDESHOW ─── */
  initHeroSlider();

  /* ─── MOBILE NAV ─── */
  initMobileNav();

  /* ─── CART DRAWER ─── */
  initCartDrawer();

  /* ─── SEARCH DRAWER ─── */
  initSearchDrawer();

  /* ─── COLLECTION TABS ─── */
  initCollectionTabs();

  /* ─── PRODUCT ACCORDION ─── */
  initAccordions();

  /* ─── PRODUCT GALLERY THUMBS ─── */
  initProductGallery();

  /* ─── ATC BUTTONS ─── */
  initAtcButtons();

  /* ─── CART ITEM CONTROLS (qty + remove) ─── */
  initCartItemControls();

  /* ─── CART PAGE CONTROLS ─── */
  initCartPage();

  /* ─── CARD QUICK ADD TO CART ─── */
  initCardAtc();

  /* ─── CARD COLOR SWATCHES ─── */
  initCardSwatches();

  /* ─── BELOW-CARD ADD TO CART ─── */
  initAtcBelow();

});

/* ─── HERO SLIDER ─── */
function initHeroSlider() {
  const sliders = document.querySelectorAll('.hero-slideshow');
  sliders.forEach(slider => {
    const slides = slider.querySelectorAll('.hero-slide');
    const dots   = slider.querySelectorAll('.hero-dot');
    if (!slides.length) return;

    let current = 0, timer;

    function goTo(n) {
      slides[current].classList.remove('active');
      if (dots[current]) dots[current].classList.remove('active');
      current = (n + slides.length) % slides.length;
      slides[current].classList.add('active');
      if (dots[current]) dots[current].classList.add('active');
    }

    function startTimer() {
      timer = setInterval(() => goTo(current + 1), 5500);
    }

    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => { clearInterval(timer); goTo(i); startTimer(); });
    });

    const prev = slider.querySelector('.hero-arrow--prev');
    const next = slider.querySelector('.hero-arrow--next');
    if (prev) prev.addEventListener('click', () => { clearInterval(timer); goTo(current - 1); startTimer(); });
    if (next) next.addEventListener('click', () => { clearInterval(timer); goTo(current + 1); startTimer(); });

    // Touch swipe
    let startX = 0;
    slider.addEventListener('touchstart', e => { startX = e.touches[0].clientX; }, { passive: true });
    slider.addEventListener('touchend', e => {
      const dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 50) { clearInterval(timer); goTo(dx < 0 ? current + 1 : current - 1); startTimer(); }
    });

    startTimer();
  });
}

/* ─── MOBILE NAV ─── */
function initMobileNav() {
  const hamburger = document.querySelector('.hamburger');
  const mobileNav = document.querySelector('.mobile-nav');
  const overlay   = document.querySelector('.mobile-nav-overlay');
  const closeBtn  = document.querySelector('.mobile-nav-close');

  function openNav() {
    mobileNav?.classList.add('open');
    hamburger?.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeNav() {
    mobileNav?.classList.remove('open');
    hamburger?.classList.remove('open');
    document.body.style.overflow = '';
  }

  hamburger?.addEventListener('click', openNav);
  overlay?.addEventListener('click', closeNav);
  closeBtn?.addEventListener('click', closeNav);
}

/* ─── CART DRAWER ─── */
function initCartDrawer() {
  const drawer  = document.querySelector('.cart-drawer');
  const overlay = document.querySelector('.drawer-overlay');
  const openBtns = document.querySelectorAll('[data-open-cart]');
  const closeBtn = drawer?.querySelector('.cart-drawer__close');

  function openCart() {
    drawer?.classList.add('open');
    overlay?.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    drawer?.classList.remove('open');
    overlay?.classList.remove('open');
    document.body.style.overflow = '';
  }

  /* Expose globally so quick-view.js and other scripts can trigger the drawer */
  window.openCartDrawer  = function () { openCart(); fetchCart(); };
  window.closeCartDrawer = closeCart;

  openBtns.forEach(btn => btn.addEventListener('click', e => {
    e.preventDefault();
    openCart();
    fetchCart();
  }));
  overlay?.addEventListener('click', closeCart);
  closeBtn?.addEventListener('click', closeCart);
}

function fetchCart() {
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      renderCart(cart);
      updateCartCount(cart.item_count);
    })
    .catch(console.error);
}

function renderCart(cart) {
  const itemsEl    = document.querySelector('.cart-drawer__items');
  const totalEl    = document.querySelector('.cart-subtotal__amount');
  const countEl    = document.querySelector('.cart-drawer__count');
  const shippingEl = document.querySelector('.cart-shipping-bar');
  const drawerEl   = document.getElementById('cart-drawer');
  if (!itemsEl) return;

  /* Read threshold UP FRONT so we can use it anywhere in this function */
  const thresholdVal  = drawerEl ? parseFloat(drawerEl.getAttribute('data-free-shipping') || '0') : 0;
  const freeThreshold = thresholdVal * 100; /* dollars → cents */

  if (countEl) countEl.textContent = `(${cart.item_count})`;

  if (!cart.items.length) {
    itemsEl.innerHTML = `
      <div class="cart-empty">
        <p>Your cart is empty.</p>
        <a href="/collections/all" class="btn btn-dark">Start Shopping</a>
      </div>`;
    if (totalEl) totalEl.textContent = formatMoney(0) + ' USD';
    if (shippingEl) shippingEl.style.display = 'none';
    return;
  }

  if (shippingEl) shippingEl.style.display = thresholdVal > 0 ? '' : 'none';

  itemsEl.innerHTML = cart.items.map(item => {
    const imgSrc = item.image
      ? item.image.replace(/(\.(jpg|jpeg|png|gif|webp))(\?.*)?$/i, '_240x$1')
      : '';
    const variantHtml = item.variant_title && item.variant_title !== 'Default Title'
      ? item.variant_title.split(' / ').map((v, i) => {
          const opts = item.options_with_values || [];
          const label = opts[i] ? opts[i].name : '';
          return `<span>${label ? `<strong>${label}:</strong> ` : ''}${v}</span>`;
        }).join('')
      : '';

    return `
    <div class="cart-item" data-key="${item.key}">
      <a href="${item.url}" class="cart-item__img">
        ${imgSrc ? `<img src="${imgSrc}" alt="${item.product_title}" loading="lazy">` : ''}
      </a>
      <div class="cart-item__info">
        <div class="cart-item__top">
          <a href="${item.url}" class="cart-item__name">${item.product_title}</a>
          <span class="cart-item__price">${formatMoney(item.final_line_price)}</span>
        </div>
        ${variantHtml ? `<div class="cart-item__variant">${variantHtml}</div>` : ''}
        <div class="cart-item__actions">
          <div class="qty-control">
            <button class="qty-btn" type="button" data-action="decrease" data-key="${item.key}" aria-label="Decrease">−</button>
            <input class="qty-input" type="number" value="${item.quantity}" min="0" data-key="${item.key}" aria-label="Quantity">
            <button class="qty-btn" type="button" data-action="increase" data-key="${item.key}" aria-label="Increase">+</button>
          </div>
          <button class="cart-item__remove" type="button" data-key="${item.key}">REMOVE</button>
        </div>
      </div>
    </div>`;
  }).join('');

  if (totalEl) totalEl.textContent = formatMoney(cart.total_price) + ' USD';

  /* Update shipping bar (threshold values already read at top of function) */
  if (shippingEl && freeThreshold > 0) {
    if (cart.item_count > 0) {
      shippingEl.style.display = '';
      const remaining = Math.max(0, freeThreshold - cart.total_price);
      const progress  = Math.min(100, (cart.total_price / freeThreshold) * 100);
      const fillEl    = shippingEl.querySelector('.cart-shipping-bar__fill');
      const textEl    = shippingEl.querySelector('.cart-shipping-bar__text');
      if (fillEl) fillEl.style.width = progress + '%';
      if (textEl) {
        if (remaining > 0) {
          textEl.className = 'cart-shipping-bar__text';
          textEl.innerHTML = `You're <strong>${formatMoney(remaining)}</strong> away from free standard shipping!`;
        } else {
          textEl.className = 'cart-shipping-bar__text cart-shipping-bar__text--reached';
          textEl.textContent = "You've unlocked free standard shipping!";
        }
      }
    } else {
      shippingEl.style.display = 'none';
    }
  }

  initQtyControls();
  initRemoveButtons();
}

function initRemoveButtons() {
  document.querySelectorAll('.cart-item__remove').forEach(btn => {
    btn.addEventListener('click', () => {
      const key = btn.dataset.key;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      })
      .then(r => r.json())
      .then(cart => { renderCart(cart); updateCartCount(cart.item_count); })
      .catch(console.error);
    });
  });
}

function updateCartCount(count) {
  document.querySelectorAll('.cart-count').forEach(el => {
    el.textContent = count;
    if (count > 0) { el.removeAttribute('hidden'); }
    else { el.setAttribute('hidden', ''); }
  });
}

function formatMoney(cents) {
  return '$' + (cents / 100).toFixed(2);
}

/* ─── SEARCH DRAWER ─── */
function initSearchDrawer() {
  /* Search drawer is now self-contained in snippets/search-drawer.liquid.
     The snippet's inline script handles open/close + live results. */
}

/* ─── COLLECTION TABS ─── */
function initCollectionTabs() {
  const tabGroups = document.querySelectorAll('[data-tabs]');
  tabGroups.forEach(group => {
    const tabs    = group.querySelectorAll('.tab-btn');
    const panels  = group.querySelectorAll('[data-tab-panel]');

    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const target = tab.dataset.tab;
        tabs.forEach(t => t.classList.remove('active'));
        panels.forEach(p => p.style.display = 'none');
        tab.classList.add('active');
        const panel = group.querySelector(`[data-tab-panel="${target}"]`);
        if (panel) panel.style.display = '';
      });
    });
  });
}

/* ─── ACCORDION ─── */
function initAccordions() {
  document.querySelectorAll('.accordion-trigger').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const content = trigger.nextElementSibling;
      const isOpen  = trigger.classList.contains('open');
      trigger.closest('.product-accordion')?.querySelectorAll('.accordion-trigger').forEach(t => {
        t.classList.remove('open');
        t.nextElementSibling?.classList.remove('open');
      });
      if (!isOpen) {
        trigger.classList.add('open');
        content?.classList.add('open');
      }
    });
  });
}

/* ─── PRODUCT GALLERY THUMBS ─── */
function initProductGallery() {
  document.querySelectorAll('.product-gallery').forEach(gallery => {
    const main   = gallery.querySelector('.product-gallery__main img');
    const thumbs = gallery.querySelectorAll('.product-gallery__thumb');

    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        const src = thumb.dataset.src;
        if (main && src) { main.src = src; }
        thumbs.forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
      });
    });
  });
}

/* ─── ATC BUTTONS (product page) ─── */
function initAtcButtons() {
  document.querySelectorAll('[data-atc]').forEach(btn => {
    btn.addEventListener('click', e => {
      e.preventDefault();
      const variantId = btn.dataset.variantId || btn.closest('[data-product]')?.dataset.variantId;
      const qty = parseInt(btn.dataset.qty || '1');
      if (!variantId) { console.warn('[ATC] No variant ID'); return; }

      const label = btn.dataset.label || btn.textContent.trim();
      btn.textContent = 'Adding…';
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty })
      })
      .then(r => { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(() => {
        btn.textContent = 'Added!';
        if (typeof window.openCartDrawer === 'function') window.openCartDrawer();
        setTimeout(() => { btn.textContent = label; btn.disabled = false; }, 1800);
      })
      .catch(() => {
        btn.textContent = 'Error — Try Again';
        btn.disabled = false;
      });
    });
  });
}

/* ─── CART QTY + REMOVE — delegated, debounced, locked ─── */

/* One pending request per cart-item key. Prevents race conditions. */
var _qtyInFlight = {};
var _qtyTimers   = {};

function initCartItemControls() {
  var itemsEl = document.querySelector('.cart-drawer__items');
  if (!itemsEl || itemsEl._cartDelegated) return;
  itemsEl._cartDelegated = true;

  itemsEl.addEventListener('click', function (e) {

    /* ── QTY BUTTONS ── */
    var btn = e.target.closest('.qty-btn');
    if (btn) {
      var key   = btn.dataset.key;
      var input = itemsEl.querySelector('.qty-input[data-key="' + key + '"]');
      if (!input || _qtyInFlight[key]) return;

      var current = parseInt(input.value) || 1;
      var next    = btn.dataset.action === 'increase' ? current + 1 : Math.max(0, current - 1);

      /* Optimistic UI */
      input.value = next;
      _setQtyLoading(key, true);

      /* Debounce: wait 300ms in case user clicks rapidly */
      clearTimeout(_qtyTimers[key]);
      _qtyTimers[key] = setTimeout(function () {
        _cartChange(key, next);
      }, 300);
      return;
    }

    /* ── REMOVE BUTTON ── */
    var rem = e.target.closest('.cart-item__remove');
    if (rem) {
      var key = rem.dataset.key;
      if (_qtyInFlight[key]) return;
      _setQtyLoading(key, true);
      _cartChange(key, 0);
    }
  });

  /* Manual input change */
  itemsEl.addEventListener('change', function (e) {
    var input = e.target.closest('.qty-input');
    if (!input) return;
    var key = input.dataset.key;
    var qty = Math.max(0, parseInt(input.value) || 0);
    input.value = qty;
    if (_qtyInFlight[key]) return;
    _setQtyLoading(key, true);
    clearTimeout(_qtyTimers[key]);
    _qtyTimers[key] = setTimeout(function () { _cartChange(key, qty); }, 300);
  });
}

function _setQtyLoading(key, loading) {
  var item = document.querySelector('.cart-item[data-key="' + key + '"]');
  if (!item) return;
  item.querySelectorAll('.qty-btn, .cart-item__remove').forEach(function (el) {
    el.disabled = loading;
    el.style.opacity = loading ? '0.45' : '';
  });
}

function _cartChange(key, qty) {
  _qtyInFlight[key] = true;
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: qty })
  })
  .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
  .then(function (cart) {
    delete _qtyInFlight[key];
    renderCart(cart);
    updateCartCount(cart.item_count);
  })
  .catch(function (err) {
    delete _qtyInFlight[key];
    console.error('[Cart] change failed:', err);
    fetchCart(); /* re-sync UI with real cart state */
  });
}

/* Keep old name so renderCart() call doesn't break */
function initQtyControls() { initCartItemControls(); }
function initRemoveButtons() { /* handled by delegation in initCartItemControls */ }

/* ─── CART PAGE (live qty + remove) ─── */
function initCartPage() {
  var form = document.getElementById('cart-form');
  if (!form || !form.classList.contains('cart-page__grid')) return;

  var cpTimers   = {};
  var cpInFlight = {};

  function setItemLoading(key, loading) {
    var item = form.querySelector('.cart-item[data-key="' + key + '"]');
    if (!item) return;
    item.style.opacity = loading ? '0.55' : '';
    item.querySelectorAll('.qty-btn, .cart-item__remove, .qty-input').forEach(function (el) {
      el.disabled = loading;
    });
  }

  function applyCart(cart) {
    if (typeof updateCartCount === 'function') updateCartCount(cart.item_count);

    if (cart.item_count === 0) {
      window.location.reload();
      return;
    }

    cart.items.forEach(function (it) {
      var row = form.querySelector('.cart-item[data-key="' + it.key + '"]');
      if (!row) return;
      var input = row.querySelector('.qty-input');
      if (input) input.value = it.quantity;
      var priceEl = row.querySelector('.cart-item__price');
      if (priceEl) priceEl.textContent = formatMoney(it.final_line_price);
    });

    form.querySelectorAll('.cart-item').forEach(function (row) {
      var key = row.getAttribute('data-key');
      var stillExists = cart.items.some(function (it) { return it.key === key; });
      if (!stillExists) row.remove();
    });

    var subtotalEl = form.querySelector('.cart-page__subtotal');
    var totalEl    = form.querySelector('.cart-page__total-amount');
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    if (totalEl)    totalEl.textContent    = formatMoney(cart.total_price);

    var countEl = form.querySelector('.cart-page__row span');
    if (countEl) countEl.textContent = 'Subtotal (' + cart.item_count + ' ' + (cart.item_count === 1 ? 'item' : 'items') + ')';
  }

  function changeQty(key, qty) {
    cpInFlight[key] = true;
    setItemLoading(key, true);
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (cart) {
        delete cpInFlight[key];
        applyCart(cart);
        setItemLoading(key, false);
      })
      .catch(function (err) {
        delete cpInFlight[key];
        setItemLoading(key, false);
        console.error('[Cart Page] change failed:', err);
      });
  }

  form.addEventListener('click', function (e) {
    var btn = e.target.closest('.qty-btn');
    if (btn) {
      var key = btn.dataset.key;
      var input = form.querySelector('.qty-input[data-key="' + key + '"]');
      if (!input || cpInFlight[key]) return;
      var current = parseInt(input.value, 10) || 1;
      var next = btn.dataset.action === 'increase' ? current + 1 : Math.max(0, current - 1);
      input.value = next;
      clearTimeout(cpTimers[key]);
      cpTimers[key] = setTimeout(function () { changeQty(key, next); }, 300);
      return;
    }
    var rem = e.target.closest('.cart-item__remove');
    if (rem) {
      var rkey = rem.dataset.key;
      if (cpInFlight[rkey]) return;
      changeQty(rkey, 0);
    }
  });

  form.addEventListener('change', function (e) {
    var input = e.target.closest('.qty-input');
    if (!input) return;
    var key = input.dataset.key;
    var qty = Math.max(0, parseInt(input.value, 10) || 0);
    input.value = qty;
    if (cpInFlight[key]) return;
    clearTimeout(cpTimers[key]);
    cpTimers[key] = setTimeout(function () { changeQty(key, qty); }, 300);
  });

  /* On checkout submit, cancel any pending debounced qty updates — the form
     POST will include the latest input values, so Shopify will apply them. */
  form.addEventListener('submit', function () {
    Object.keys(cpTimers).forEach(function (k) { clearTimeout(cpTimers[k]); });
  });
}

/* ─── BELOW-CARD ADD TO CART BUTTON ─── */
function initAtcBelow() {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.js-atc-below');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    var variantId = btn.getAttribute('data-variant-id');
    var isSingle  = btn.getAttribute('data-single') === 'true';
    var handle    = btn.getAttribute('data-handle');

    if (!isSingle) {
      if (typeof window.openQuickView === 'function') {
        window.openQuickView(handle);
      } else {
        window.location.href = btn.href;
      }
      return;
    }

    if (btn.classList.contains('is-adding')) return;
    btn.classList.add('is-adding');

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
    .then(function (r) { if (!r.ok) throw new Error('failed'); return r.json(); })
    .then(function () {
      btn.classList.remove('is-adding');
      btn.classList.add('is-added');
      if (typeof window.openCartDrawer === 'function') window.openCartDrawer();
      setTimeout(function () { btn.classList.remove('is-added'); }, 2200);
    })
    .catch(function () {
      btn.classList.remove('is-adding');
    });
  });
}

/* ─── CARD COLOR SWATCH: swap image + name on click ─── */
function initCardSwatches() {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.js-card-swatch');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    var card = btn.closest('[data-product]');
    if (!card) return;

    /* highlight active swatch */
    card.querySelectorAll('.js-card-swatch').forEach(function (s) { s.classList.remove('is-active'); });
    btn.classList.add('is-active');

    /* update color name */
    var color = btn.getAttribute('data-color');
    var nameEl = card.querySelector('.pc__color-name');
    if (nameEl && color) nameEl.textContent = color;

    /* swap primary image */
    var img = btn.getAttribute('data-img');
    var primary = card.querySelector('.pc__img--primary');
    if (img && primary) {
      primary.removeAttribute('srcset');
      primary.src = img;
    }
  });
}

/* ─── CARD QUICK ADD TO CART ─── */
function initCardAtc() {
  var PLUS_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" width="16" height="16"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>';
  var CHECK_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" width="14" height="14"><polyline points="20 6 9 17 4 12"/></svg>';

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.js-card-atc');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    var variantId = btn.getAttribute('data-variant-id');
    var isSingle  = btn.getAttribute('data-single') === 'true';
    var handle    = btn.getAttribute('data-handle');

    /* Multi-variant: open quick view so the user can pick */
    if (!isSingle) {
      if (typeof window.openQuickView === 'function') window.openQuickView(handle);
      return;
    }

    if (btn.disabled) return;
    btn.disabled = true;
    btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" width="14" height="14"><circle cx="12" cy="12" r="3" fill="currentColor" opacity="0.5"/></svg>';

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
    .then(function (r) {
      if (!r.ok) throw new Error('Add failed');
      return r.json();
    })
    .then(function () {
      btn.innerHTML = CHECK_SVG;
      if (typeof window.openCartDrawer === 'function') window.openCartDrawer();
      setTimeout(function () {
        btn.innerHTML = PLUS_SVG;
        btn.disabled = false;
      }, 1800);
    })
    .catch(function (err) {
      console.error('[ATC] Card add failed:', err);
      btn.innerHTML = PLUS_SVG;
      btn.disabled = false;
    });
  });
}
